import { useRef, useState } from "react";
import { acdCodes } from "../../utils/acdCodes";
import moment from "moment";
import 'moment/locale/es';
import { actions, basis, dueProcess, extent, stagingState, suffix } from "../../utils/withdrawalOptions";
import { useNavigate } from "react-router-dom";
import { buildAddWithdrawal, buildUpdateFcwdDriverInfo, linkedConvictions, defaultDriverData, isNewUser, makeWithdrawalObjectForAdd, postJson, setDefaultDriverData, toYMD, setLinkedConvictions, generateReasonRefCode, generateWdLocatorRef, isDown, buildAddStageWithdrawal, errMessage, ccContacts, toPascalCaseWithHyphens, foreignData, fcwdOnly } from "../../utils/data";
import { canadianProvinces, countryOptions } from "../../utils/countryOptions";
import { useAuth } from "../../context/AuthContext";
import { withdrawalIssues } from "../../utils/messages";
import { saveAs } from 'file-saver';
import Loading from "../tabs/loading";

function AddStagingWithdrawal() {

    const {source, email, userState, token} = useAuth();
    const acdDetailsRef = useRef(null);
    const navigate = useNavigate();
    const [extentCode, setExtentCode] = useState("1");
    const [acdCode, setAcdCode] = useState("");
    const [selectedAcd, setSelectedAcd] = useState(null);
    const [selectedDueProcess, setDueProcess] = useState("2");
    const [indefPerm, setIndefPerm] = useState("");
    const [selectedBasis, setBasis] = useState("1");
    const [action, setAction] = useState("6");
    const [comments, setComments] = useState("Withdrawal Added");
    const [stateNative, setStateNative] = useState(generateReasonRefCode("FH"));
    const [locator, setLocator] = useState(generateWdLocatorRef());
    const [reinstatementDate, setReinstatementDate] = useState("");
    const [eligibilityDate, setEligibilityDate] = useState("");
    const [effectiveDate, setEffectiveDate] = useState("");
    const [duration, setDuration] = useState("");
    const [notice, setNotice] = useState("");
    const [dqNeeded, setDqNeeded] = useState("1");
    const [dqSendDate, setDqSendDate] = useState(isDown === 'Yes' ? '' : moment().format("YYYY-MM-DD"));
    const [dqMailDate, setDqMailDate] = useState("");
    const [jurisdiction, setJurisdiction] = useState("FH");
    const [daysYears, setDaysYears] = useState("day(s)");
    const [maxVal , setMaxVal] = useState(0);
    const [newUser, setNewUser] = useState({});
    const [validated, setValidated] = useState(false);
    const [err, setErr] = useState([]);
    const [loading, setLoading] = useState(false);
    const screenRef = useRef(null);
    const errRef = useRef(null);
    
    const dataSource = {DataSource: source, CAorMXDown: isDown, userId: email};
    const userType = "DEFAULT"; // Replace with actual user state logic

    const handleAcdChange = (e) => {
        const code = e.target.value; // Reset ACD Details input
        setAcdCode(code);
        console.log(`Selected ACD Code: ${code}`);
        if (acdDetailsRef.current) {
            acdDetailsRef.current.value = ""; // clear the input field
        }
        code === "S92" ? setMaxVal(5) : 
        code.startsWith("D") ? setMaxVal(3) :
        setMaxVal(2);
        const found = acdCodes.find(a => a.code === code);
        setSelectedAcd(found || null);
    }

    const  handleCancel = (e) => {
        e.preventDefault();
        navigate(-1);
    }

    const updateEligibleEffectiveDates = () => {
        // If notice + daysYears present -> compute effective = today + notice (days or years)
        if (notice !== "") {
            const amt = Number(notice) || 0;
            // daysYears should be "days" or "years"
            const newEff = moment().add(amt, "days").format("YYYY-MM-DD");
            if (newEff !== effectiveDate){
                console.log("New Effective Date", newEff, effectiveDate);
                setEffectiveDate(newEff);
            }
        }

        // If duration + effectiveDate present -> compute eligibility = effectiveDate + duration days
        if (duration !== "" && effectiveDate && daysYears) {
            const days = Number(duration) || 0;
            const newElig = moment(effectiveDate, "YYYY-MM-DD").add(days, daysYears).format("YYYY-MM-DD");
            console.log("New Eligible Date", newElig);
            setEligibilityDate(newElig);
            return;
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr('');
        const form = e.target;
        const submittedButton = e.nativeEvent.submitter;
        
        if(submittedButton.id === "saveNoFC"){
            dataSource.CAorMXDown = 'Yes';
        }
        window.scrollTo(0, 0);
        if (form.checkValidity() === false) {
        e.stopPropagation(); // prevent submit if invalid
        } else {
            console.log("Selected ACD", selectedAcd.linkageReq, linkedConvictions.length);
            if(linkedConvictions.length === 0 && selectedAcd.linkageReq){
                setErr(<><div class="alert alert-danger" role="alert">Linkage needed for ACD Code {acdCode}</div></>)
            } else{
                console.log("Submit in progress", )
                const convictions = linkedConvictions
                console.log("Selected Convictions", convictions);
                const withdrawal = {
                    JurisdictionCodeWithdrawing: jurisdiction ?? userState,
                    DriverLicenseWithdrawalEffectiveDate: effectiveDate,
                    DriverLicenseWithdrawalType: action,
                    DriverLicenseWithdrawalBasis: selectedBasis,
                    DLWithdrawalDueProcessStatus: selectedDueProcess,
                    DRVLicAcdWithdrawalReasonCode: acdCode,
                    DRVLicWithdrawalEligibilityDate: indefPerm === '' ? eligibilityDate : indefPerm.toUpperCase(),
                    DLWithdrawalReinstatementDate: reinstatementDate,
                    DRVLicWithdrawalExtentIdDlc: extentCode,
                    DLWithdrawalJurisdictionReportId: locator,
                    DRVLicWithdrawalReasonReference: stateNative,
                    WithdrawalCategory: "",
                    WithdrawalNoticePeriod: notice,
                    WithdrawalDuration: duration,
                    WithdrawalReinstLetterSentDate: reinstatementDate,
                    WithdrawalDisqLetterNeeded: dqNeeded,
                    WithdrawalDisqLetterSentDate: dqSendDate,
                    WithdrawalDQLetterMailedDate: dqMailDate,
                    WithdrawalStatusNotes: comments,
                    WithdrawalUserId: email,
                    WithdrawalDateReceived: moment().format("YYYYMMDD"),
                    WithdrawalDatePosted: moment().format("YYYYMMDD"),
                }
                console.log("C: "+JSON.stringify(linkedConvictions))
                console.log("W: "+JSON.stringify(withdrawal))
                const issues = withdrawalIssues(withdrawal, linkedConvictions);
                if (issues.length) {
                    setErr(issues.map((m, i) => <div key={i} style={{color:'red'}}>{m}</div>));
                    return; // prevent POST if validation fails
                }
                setLoading(true);
                const {firstName, middleName, surName, suffix, street1, street2, city, county, state, zip, country, driverState, driverLicense} = fcwdOnly || submittedButton.id === "saveNoFC" ? defaultDriverData : foreignData;
                const address = `${street1} ${street2 || ''}`.trim();
                // const state = fcwdOnly ? defaultDriverData.driverState : foreignData.driverState || defaultDriverData.driverState;
                const letterJson = {
                    TemplateType: 'disqualificationLetter.docx',
                    showMXBlock: driverState === 'MX',
                    showCABlock:canadianProvinces.some(prov => prov.code === driverState),
                    Date: moment().locale('en').format("MMMM DD, YYYY"),
                    MXDate: moment().locale('es').format("DD [de] MMMM [de] YYYY"),
                    FullName: `${toPascalCaseWithHyphens(firstName)} ${middleName ? toPascalCaseWithHyphens(middleName) + ' ' : ''}${toPascalCaseWithHyphens(surName)}${suffix || ''}`.trim(),
                    ST: driverState,
                    DLN: driverLicense,
                    Address: address,
                    County: county,
                    City: city,
                    State: state || driverState,
                    Country: country,
                    ZipCode: zip,
                    convictionListIntro: linkedConvictions.length === 1 ? "is" : "are",
                    Duration: duration + ' ' + daysYears,
                    EffectiveDate: effectiveDate !== '' ? moment(effectiveDate).format("MM/DD/YYYY"): '',
                    MXEffectiveDate: effectiveDate !== '' ? moment(effectiveDate).format("DD/MM/YYYY"): '',
                    EligibilityDate: indefPerm !== '' ? indefPerm.toUpperCase() : eligibilityDate !== '' ? moment(eligibilityDate).format("M/D/YYYY"): '',
                    MXEligibilityDate: indefPerm !== '' ? indefPerm.toUpperCase() : eligibilityDate !== '' ? moment(eligibilityDate).format("DD/MM/YYYY"): '',
                    EligibilityBlockMX:
                        indefPerm === "" ?
                            `Se determinará sobre su privilegio de conducir un CMV dentro del territorio de los Estados Unidos cuando expire su período de prohibición, el ${eligibilityDate !== '' && moment(eligibilityDate).format("M/D/YYYY")}.`
                            : `Con base en su historial de Infracciones, a usted ya no se le permite operar un CMV en los Estados Unidos.`,
                    EligibilityBlock:
                        indefPerm === ""
                            ? `A determination will be made as to your privilege to operate a CMV within the borders of the United States upon the expiration of your prohibition period on ${eligibilityDate !== '' && moment(eligibilityDate).format("M/D/YYYY")}.`
                            : `Based on your history of convictions, you are no longer permitted to operate a CMV in the United States.`,
                    showConvictionsTable: linkedConvictions.length > 0,
                    convictions: linkedConvictions.map(c => ({
                        CitationDate: moment(c.CitationDate).format("YYYYMMDD"),
                        ConvictionDate: moment(c.ConvictionDate).format("YYYYMMDD"),
                        DOC: moment(c.ConvictionDate).locale('en').format("MMMM DD, YYYY"),
                        MXDOC: moment(c.ConvictionDate).locale('es').format("DD [de] MMMM [de] YYYY"),
                        ConvictionID: c.ConvictionIdCode,
                        StateOfConviction: c.JurisdictionCodeConvicting,
                        CourtType: c.ConvictionCourtType?.split('-')[0] || c.ConvictionCourtType,
                        ACDCode: c.ConvictionOffenseAcdCode?.Code + ' - ' + c.ConvictionOffenseAcdCode?.Description.toUpperCase(),
                        ACDDetail: c.ConvictionOffenseDetailAcd,
                        CDLHolder: c.CitationCdlHolderIndicator?.split('-')[1] || c.CitationCdlHolderIndicator,
                        CMV: c.ConvictionCommercialVehInd?.split('-')[1] || c.ConvictionCommercialVehInd,
                        Hazmat: c.ConvictionHazmatInd?.split('-')[1] || c.ConvictionHazmatInd,
                        LocatorReference: c.ConvictionJurisCourtReportId,
                        StateCode: c.ConvictionJurisdictionOffenseCode
                    })),
                };
                if(letterJson.County === ""){
                    letterJson.County = null;
                }
                console.log("LETTER JSON → ", letterJson);
                if (!letterJson.Address.trim() || !letterJson.City.trim()) {
                    setErr("Address and City are required for Staging Withdrawal.");
                    setLoading(false);
                    return;
                } else {
                    const driverInfo = fcwdOnly ? defaultDriverData : foreignData;
                    const build = buildAddStageWithdrawal({driver: driverInfo, convictions: convictions, withdrawal: withdrawal, sourceOpts: dataSource})
                    console.log("Have request for add Withdrawal", build);
                    await postJson('/api/stage/withdrawal/add', build, null, token)
                    .then(async function(response) {
                        console.log("Response sent")
                        if (response.Status === "SUCCESS"){
                            if (dqNeeded === '1') {
                                // Build JSON for disqualification letter Why was this created in the first place
                                // await postJson('/api/generate/dqReinDocx', {
                                //     letterJson: letterJson.DLN.includes('*') ? null : letterJson,
                                //     to: email,   // or driver email / agency email
                                //     subject: letterJson.DLN.includes('*') ? `Manual Disqualification Needed for a Driver in ${letterJson.Country}` : `FMCSA Disqualification Notice for a Driver in ${letterJson.Country}`,
                                //     bodyText: letterJson.DLN.includes('*') ? "Please manually create disqualification letter" : "Please see the attached FMCSA Disqualification Notice.",
                                // })
                                await postJson('/api/generate/dqReinDocx', {
                                    letterJson: letterJson,
                                    to: email,   // or driver email / agency email
                                    subject: `FMCSA Disqualification Notice for a Driver in ${letterJson.Country}`,
                                    bodyText: "Please see the attached FMCSA Disqualification Notice.",
                                }, null, token)
                                .then((response) => {
                                    console.log("Generated Letter Docx", response);
                                })
                                .catch((err) => {
                                    setLoading(false);
                                    setErr("Error sending letter docx: " + err);
                                });
                                // if(reinstatementDate !== ''){
                                //     // Build JSON for reinstatement letter
                                //     const reinLetterJson = {
                                //         TemplateType: 'reinstatementLetter.docx',
                                //         showMXBlock: letterJson.showMXBlock,
                                //         showCABlock: letterJson.showCABlock,
                                //         Date: moment().format("MMMM DD, YYYY"),
                                //         MXDate: moment().locale('es').format("DD [de] MMMM [de] YYYY"),
                                //         FullName: letterJson.FullName,
                                //         LastName: letterJson.LastName,
                                //         ST: letterJson.ST,
                                //         DLN: letterJson.DLN,
                                //         Address: address,
                                //         County: letterJson.County,
                                //         City: letterJson.City,
                                //         State: letterJson.State,
                                //         Country: letterJson.Country,
                                //         ZipCode: letterJson.ZipCode,
                                //         ReinstatementDate: moment(reinstatementDate).format("MM/DD/YYYY"),
                                //         MXReinstatementDate: moment(reinstatementDate).locale('es').format("DD/MM/YYYY"),
                                //     };
                                //     await postJson('/api/generate/dqReinDocx', {

                                //         letterJson: reinLetterJson,
                                //         to: email,   // or driver email / agency email
                                //         subject: `FMCSA Reinstatement Notice for a Driver in ${letterJson.Country}`,
                                //         bodyText: "Please see the attached FMCSA Reinstatement Notice.",
                                //     })
                                //     .then((response) => {
                                //         console.log("Generated Letter Docx", response);
                                //     })
                                //     .catch((err) => {
                                //         setLoading(false);
                                //         setErr("Error sending letter docx: " + err);
                                //     });
                                // }
                            }
                            setErr()
                            navigate(-1);
                        }
                        setErr(response.Messages[0])
                    })
                    .catch(function(error) {
                        setErr("Error submitting Withdrawal: "+error.message);
                    });
                }
            }
            setLoading(false);
        }
        setValidated(true); 
    }
  
      return (
          <>
              <div className="App">
                <div style={{color: 'red'}}>{err}</div>
                <div ref={screenRef}></div>
                <div>{errMessage}</div>
                {loading &&
                        <Loading />}
                  <h1>Manual Withdrawal [Add To Staging]</h1>
                  <div id="table">
                      <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
                          <div className="row">
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver State</b></label>
                                  <input className="form-control" type="text"
                                  value={defaultDriverData.driverState} disabled />
                              </div>
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver License</b></label>
                                  <input className="form-control" type="text"
                                  value={defaultDriverData.driverLicense} disabled />
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-md-3">
                                  <label className="form-label"><b>Withdrawal Effective Date </b></label>
                                  <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" 
                                      name='effectiveDate' 
                                      max={moment().format("YYYYMMDD")}
                                      value={effectiveDate}
                                      onChange={(e) => setEffectiveDate(e.target.value)}
                                        />
                                    <div className="invalid-feedback">Please enter an Effective Date</div>
                              </div>
                            {indefPerm !== null && indefPerm === "" ? 
                                <div className="col-md-3">
                                <label className="form-label"><b>Withdrawal Eligible Date</b></label>
                                    <input type="date" className="form-control"
                                        value={eligibilityDate}
                                        placeholder="MM/DD/YYYY" name='convictionDate' min={effectiveDate}
                                        onChange={(e) =>  setEligibilityDate(e.target.value)}
                                     />
                                    <div className="invalid-feedback">Please enter a valid Eligible Date</div>
                            </div> :
                            <div className="col-md-3">
                                <label className="form-label"><b>Withdrawal Eligible Date</b></label>
                                <input type="date" className="form-control"
                                    onChange={(e) => (e.target.value)}
                                    placeholder="MM/DD/YYYY" name='convictionDate'
                                    
                                    readOnly />
                                </div>}
                            
                            <div className="col-md-3">
                                <label className="form-label"><b>Indef/Perm</b></label>
                                <select className="form-select"
                                    value={indefPerm}
                                    onChange={(e) => setIndefPerm(e.target.value)}
                                >
                                    <option value="">-- INDEF/PERM --</option>
                                    <option value="indef">INDEF</option>
                                    <option value="perm">PERM</option>
                                </select>
                            </div>
                            
                            <div className="col-md-3">
                                    <label className="form-label"><b>Withdrawal Reinstated Date</b></label>
                                    <input type="date" className="form-control" 
                                        value={reinstatementDate}
                                        onChange={(e) => setReinstatementDate(e.target.value)}
                                        max={moment().format("YYYYMMDD")}
                                        placeholder="MM/DD/YYYY" name='convictionDate'/>
                                </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3">
                                  <label className="form-label"><b>Notice Period</b></label>
                                  <span>(numbers only)</span>
                                    {duration !== '' ? (
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={notice}
                                        onChange={(e) => setNotice(e.target.value)}
                                        name="notice"
                                        maxLength={3}
                                        disabled
                                      />
                                    ) : (
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={notice}
                                        onChange={(e) => setNotice(e.target.value)}
                                        name="notice"
                                        maxLength={3}
                                      />
                                    )}
                              </div>
                              <div className="col-md-4">
                                  <label className="form-label"><b>Duration for Eligible Date</b> <span>(numbers only)</span></label>
                                  <div className="d-flex align-items-center">
                                  <input type="text" className="form-control"
                                        value={duration}
                                        style={{ maxWidth: '60%' }}
                                        onChange={(e) => setDuration(e.target.value)}
                                        name="notice" maxLength={3}  />
                                    <select
                                      className="form-select"
                                      value={daysYears}
                                      onChange={(e) => setDaysYears(e.target.value)}
                                      style={{ maxWidth: '40%' }}
                                    >
                                      <option value="">-- Days/Years --</option>
                                      <option value="day(s)">Days</option>
                                      <option value="year(s)">Years</option>
                                    </select>
                                  </div>
                              </div>
                              <div className="col-md-3 align-self-end">
                              <button type="button" class="btn btn-secondary" onClick={updateEligibleEffectiveDates}>Update Dates</button>
                              </div>
                          </div>
  
                          <div className="row">
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Action</b></label>
                                  <select className="form-select"
                                      value={action}
                                      onChange={(e) => setAction(e.target.value)}
                                       required >
                                        <option value="" disabled>-- Action --</option>
                                      {actions[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select an Action</div>
                                </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Basis</b></label>
                                  <select className="form-select"
                                      value={selectedBasis}
                                      onChange={(e) => setBasis(e.target.value)}
                                       required
                                  >
                                      <option value="" disabled>-- Basis --</option>
                                      {basis[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select a Basis</div>
                              </div>
                              <div className="col-md-3">
                                <label className="form-label mt-2"><b><span className="text-danger">*</span> Withdrawal Jurisdiction</b></label>
                                  <select className="form-select"
                                    value={jurisdiction}
                                    onChange={(e) => setJurisdiction(e.target.value)}
                                    required
                                    >
                                        <option value="" disabled>-- Jurisdiction --</option>
                                        <option value="FH">FH</option>
                                        {stagingState.map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                                {opt.code}
                                            </option> ))}
                                    </select>
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Due Process Status</b></label>
                                  <select className="form-select"
                                      value={selectedDueProcess}
                                      onChange={(e) => setDueProcess(e.target.value)}
                                       required
                                  >
                                      <option value="" disabled>-- Due Process --</option>
                                      {dueProcess[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select a Due Process Status</div>
                              </div>
                              
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> ACD Code</b></label>
                                    <select className="form-select"
                                        value={acdCode}
                                        onChange={handleAcdChange}
                                         required
                                    >
                                        <option value="" disabled>-- ACD Code --</option>
                                        {acdCodes.map((opt) => (
                                            <option key={opt.code} value={opt.code} title={opt.label}>
                                                {opt.code} - {opt.simple}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">Please select an ACD Code</div>
                                </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Extent Code</b></label>
                                  <select className="form-select"
                                      value={extentCode}
                                      onChange={(e) => setExtentCode(e.target.value)}
                                       required
                                  >
                                      <option value="" disabled>-- Extent Code --</option>
                                      {extent[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select an Extent Code</div>
                              </div>
                          </div>
                          <div className="row">
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Locator Number</b></label>
                                  <input type="text" className="form-control" name="locator" 
                                  value={locator}
                                  onChange={(e) =>setLocator(e.target.value)}
                                  maxLength={18}  required />
                                  <div className="invalid-feedback">Please enter a Withdrawal Locator Number</div>
                              </div>
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span>Reason Ref Code</b></label>
                                  <input type="text" className="form-control" name="stateNative"
                                  value={stateNative}
                                  onChange={(e)=>setStateNative(e.target.value)}
                                  maxLength={8}  required />
                                  <div className="invalid-feedback">Please enter a Reason Ref Code</div>
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                                <label className="form-label"><b>Needs Disqualification Letter</b></label>
                                <select className="form-select"
                                    value={dqNeeded}
                                    onChange={(e) => setDqNeeded(e.target.value)}
                                    disabled
                                >
                                    <option value="" disabled>-- Select --</option>
                                    <option value="1">1 - Yes</option>
                                    <option value="0">0 - No</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label"><b>Disqualification Letter Emailed</b></label>
                                <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" 
                                      name='DQSendDate' 
                                      max={moment().format("YYYYMMDD")}
                                      onChange={(e) => setDqSendDate(e.target.value)}
                                      value={dqSendDate}
                                      disabled
                                    />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label"><b>Disqualification Letter Mailed</b></label>
                                <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" 
                                      name='DQSendDate' 
                                      max={moment().format("YYYYMMDD")}
                                      onChange={(e) => setDqMailDate(e.target.value)}
                                      value={dqMailDate}
                                    />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                                <label className="form-label"><b>Withdrawal Posted Date</b></label>
                                <input type="date" className="form-control" 
                                    placeholder="MM/DD/YYYY" 
                                    name='postedDate'            
                                    value={moment().format("YYYY-MM-DD")}
                                    disabled />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label"><b>User ID</b></label>
                                <input type="text" className="form-control"
                                value={email}
                                name="userId" disabled />
                            </div>
                        </div>
                        {/* {!loading ?
                          <button type="submit" className="btn btn-primary mt-3">
                            Stage Withdrawal
                          </button> :
                          <button type="submit" className="btn btn-primary mt-3">
                            <Loading />
                          </button>
                        } */}
                          <button type="submit" id="saveFC" className="btn btn-primary mt-3 m-2" disabled={isDown === "Yes" || fcwdOnly}>
                            Save
                          </button>
                          <button type="submit" id="saveNoFC" className="btn btn-primary mt-3 m-2">
                            Save No FC
                          </button>
                          <button type="button" onClick={(e) => handleCancel(e)} 
                          className="btn btn-secondary mt-3 m-2">
                            Back to Details for DL:{defaultDriverData.driverLicense}
                          </button>
                      </form>
                  </div>
                  {linkedConvictions.length > 0 && 
                          <table className="table table-striped table-bordered" style={{fontSize: 'smaller'}}>
        <thead style={{width: '100%'}}>
            <tr>
                <th scope="col">Select</th>
                <th scope="col">Driver State</th>
                <th scope="col">Driver License</th>
                <th scope="col">Citation Date</th>
                <th scope="col">Conv Date</th>
                <th scope="col">Conv ID</th>
                <th scope="col">SOC</th>
                <th scope="col">Court Type</th>
                <th scope="col">ACD</th>
                <th scope="col">Detail</th>
                <th scope="col">CDL</th>
                <th scope="col">CMV</th>
                <th scope="col">Haz Mat</th>
                <th scope="col">Conv Offense Loc</th>
                <th scope="col">State Native Code</th>
                <th scope="col">Category</th>
                <th scope="col">User ID</th>
                <th scope="col">Date Posted</th>
            </tr>
        </thead>
        <tbody>
          {linkedConvictions.map(conviction => (
            <tr>
                <td><input type="checkbox" aria-label="Checkbox for following text input" checked disabled/></td>
                <td id="cState">{defaultDriverData.driverState}</td>
                <td id="cLicense">{defaultDriverData.driverLicense}</td>
                <td id="cCitationDate">{conviction.CitationDate}</td>
                <td id="cConvDate">{conviction.ConvictionDate}</td>
                <td id="convID">{conviction.ConvictionIdCode}</td>
                <td id="SOC">{conviction.JurisdictionCodeConvicting}</td>
                {conviction.ConvictionCourtType !== "" && conviction.ConvictionCourtType.split('-')[1] ? <td id="cCourt">{conviction.ConvictionCourtType.split('-')[1]}</td> : <td id="cCourt">{conviction.ConvictionCourtType}</td>}
                <td id="cACD">{conviction?.ConvictionOffenseAcdCode?.Code}</td>
                <td id="cDetail">{conviction.ConvictionOffenseDetailAcd}</td>
                {conviction.CitationCdlHolderIndicator !== "" && conviction.CitationCdlHolderIndicator.split('-')[1] ? <td id="cCDL">{conviction.CitationCdlHolderIndicator.split('-')[1]}</td> : <td id="cCDL">{conviction.CitationCdlHolderIndicator}</td>}
                {conviction.ConvictionCommercialVehInd !== "" && conviction.ConvictionCommercialVehInd.split('-')[1] ? <td id="CMV">{conviction.ConvictionCommercialVehInd.split('-')[1]}</td> : <td id="CMV">{conviction.ConvictionCommercialVehInd}</td>}
                {conviction.ConvictionHazmatInd !== "" && conviction.ConvictionHazmatInd.split('-')[1] ? <td id="cHazmat">{conviction.ConvictionHazmatInd.split('-')[1]}</td> : <td id="cHazmat">{conviction.ConvictionHazmatInd}</td>}
                <td id="cConvOff">{conviction.ConvictionJurisCourtReportId}</td>
                <td id="cStateNative">{conviction.ConvictionJurisdictionOffenseCode}</td>
                <td id="cCategory">{conviction.ConvictionCategory}</td>
                <td id="cUserID">{conviction.ConvictionUserID}</td>
                <td id="cDatePosted">{conviction.ConvictionDatePosted}</td>
            </tr>
            ))}
            

        </tbody>
        </table>}
              </div>
  
              {/* Modal for ACD Info */}
              {selectedAcd && (
                  <div className="modal fade" id="acdInfoModal" tabIndex="-1" aria-labelledby="acdInfoModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                          <div className="modal-content">
                              <div className="modal-header">
                                  <h5 className="modal-title" id="acdInfoModalLabel">ACD Code Information</h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div className="modal-body">
                                  <p><strong>ACD Code:</strong> {selectedAcd.code}</p>
                                  <p><strong>Description:</strong> {selectedAcd.label}</p>
                                  {selectedAcd.validation && (
                                      <p><strong>Validation:</strong> {selectedAcd.validation}</p>
                                  )}
                                  {selectedAcd.moreInfo && (
                                      <p><strong>More Info:</strong> {selectedAcd.moreInfo}</p>
                                  )}
                              </div>
                              <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                              </div>
                          </div>
                      </div>
                  </div>
              )}
          </>
      );
}

export default AddStagingWithdrawal;